import {
  adjustmentSessionIdFormat,
  inboundShipmentIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import * as z from "zod";

import { AdjustmentSessionKind } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";

const AdjustmentSessionListItemSchema_ = z.object({
  id: adjustmentSessionIdFormat.schema,
  displayId: z.string(),
  locationId: locationIdFormat.schema,
  locationName: z.string(),
  legacyUserId: z.string(),
  teamMemberName: z.string().nullable(),
  teamMemberEmail: z.string().nullable(),
  kind: createEnum(AdjustmentSessionKind),
  sourceId: z.string().nullable(),
  inboundShipmentId: inboundShipmentIdFormat.schema.nullable(),
  inboundShipmentNumber: z.string().nullable(),
  parentSessionId: adjustmentSessionIdFormat.schema.nullable(),
  notes: z.string().nullish(),
  status: createEnum([
    "in_progress",
    "submitted",
    "completed",
    "cancelled",
    "reversed",
  ]),
  productCount: z.number(),
  totalQuantity: z.number(),
  totalDamaged: z.number(),
  totalMissing: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  submittedAt: z.string().nullable(),
  completedAt: z.string().nullable(),
  deletedAt: z.string().nullable(),
});

export const AdjustmentSessionListItemSchema: z.ZodType<AdjustmentSessionListItemSchema> =
  AdjustmentSessionListItemSchema_;
export interface AdjustmentSessionListItemSchema extends z.infer<
  typeof AdjustmentSessionListItemSchema_
> {}

export const listAdjustmentSessions = {
  name: "listAdjustmentSessions" as const,
  input: z.object({
    locationId: locationIdFormat.schema.optional(),
    inboundShipmentId: inboundShipmentIdFormat.schema.optional(),
    status: createEnum([
      "in_progress",
      "submitted",
      "completed",
      "cancelled",
      "reversed",
    ]).optional(),
    limit: z.number().optional(),
    offset: z.number().optional(),
  }),
  output: z.object({
    sessions: z.array(AdjustmentSessionListItemSchema),
    total: z.number(),
  }),
};
